export default __webpack_public_path__ + "static/media/product-screen-ru.57fb1408.png";